// Order related data to support the UI

// Status of the order
export const OrderStatus = {
  AWAITING_PAYMENT: "awaiting_payment",
};
